'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _components = require('I18n/components');

var _UICard = require('UIComponents/card/UICard');

var _UICard2 = _interopRequireDefault(_UICard);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _LegalConsentInputs = require('MeetingsLib/components/input/LegalConsentInputs');

var _LegalConsentInputs2 = _interopRequireDefault(_LegalConsentInputs);

var _StepButtonsFooter = require('MeetingsLib/components/page/StepButtonsFooter');

var _StepButtonsFooter2 = _interopRequireDefault(_StepButtonsFooter);

var _LegalConsentOptions = require('MeetingsBase/models/LegalConsentOptions');

var _LegalConsentOptions2 = _interopRequireDefault(_LegalConsentOptions);

var _LegalConsentFormSelectors = require('MeetingsLib/selectors/LegalConsentFormSelectors');

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

var FormActions = _interopRequireWildcard(_FormActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegalConsentForm = _react2.default.createClass({
  displayName: 'LegalConsentForm',

  propTypes: {
    // passed
    submittingMeeting: _react.PropTypes.bool,
    goToPreviousStep: _react.PropTypes.func.isRequired,
    // loaded
    legalConsentOptions: _react.PropTypes.instanceOf(_LegalConsentOptions2.default).isRequired,
    stagedLegalConsentResponses: _react.PropTypes.instanceOf(_immutable.List),
    setGivenConsent: _react.PropTypes.func.isRequired,
    resetConsentResponses: _react.PropTypes.func.isRequired,
    submitConsentResponses: _react.PropTypes.func.isRequired,
    allRequiredConsentCollected: _react.PropTypes.bool.isRequired
  },

  handleGoBack: function handleGoBack() {
    var _props = this.props,
        resetConsentResponses = _props.resetConsentResponses,
        goToPreviousStep = _props.goToPreviousStep;

    resetConsentResponses();
    goToPreviousStep();
  },
  handleSubmit: function handleSubmit() {
    var _props2 = this.props,
        stagedLegalConsentResponses = _props2.stagedLegalConsentResponses,
        submitConsentResponses = _props2.submitConsentResponses;

    submitConsentResponses(stagedLegalConsentResponses);
  },
  renderHeader: function renderHeader() {
    return _react2.default.createElement(
      'h4',
      { className: 'p-x-1 m-bottom-5' },
      _react2.default.createElement(_components.FormattedMessage, { message: 'dataPrivacy' })
    );
  },
  renderFormButtons: function renderFormButtons() {
    var _props3 = this.props,
        submittingMeeting = _props3.submittingMeeting,
        allRequiredConsentCollected = _props3.allRequiredConsentCollected;

    return _react2.default.createElement(_StepButtonsFooter2.default, {
      submittingMeeting: submittingMeeting,
      canProceed: allRequiredConsentCollected,
      isLastStep: true,
      goToPreviousStep: this.handleGoBack,
      goToNextStep: this.handleSubmit
    });
  },
  renderLegalConsentInputs: function renderLegalConsentInputs() {
    var _props4 = this.props,
        legalConsentOptions = _props4.legalConsentOptions,
        stagedLegalConsentResponses = _props4.stagedLegalConsentResponses,
        setGivenConsent = _props4.setGivenConsent;

    return _react2.default.createElement(
      'div',
      { className: 'form-body width-100 m-bottom-3 overflow-y-scroll overflow-x-hidden' },
      _react2.default.createElement(_LegalConsentInputs2.default, {
        legalConsentResponses: stagedLegalConsentResponses,
        legalConsentOptions: legalConsentOptions,
        setGivenConsent: setGivenConsent
      })
    );
  },
  render: function render() {
    return _react2.default.createElement(
      _UICard2.default,
      { className: 'height-100 p-y-6' },
      _react2.default.createElement(
        _UIFlex2.default,
        { className: 'height-100', direction: 'column', justify: 'around' },
        this.renderHeader(),
        this.renderLegalConsentInputs(),
        this.renderFormButtons()
      )
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    allRequiredConsentCollected: (0, _LegalConsentFormSelectors.getAllStagedRequiredConsentCollected)(state),
    legalConsentOptions: (0, _get2.default)('legalConsentOptions', (0, _BookInfoSelectors.getCustomParams)(state)),
    stagedLegalConsentResponses: (0, _LegalConsentFormSelectors.getStagedLegalConsentResponses)(state)
  };
}, _extends({}, FormActions))(LegalConsentForm);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/sections/LegalConsentForm.js
// module id = 233
// module chunks = 0